import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company, CompanyMenu, UserRole } from '@shared/definitions';

@Injectable({
  providedIn: 'root',
})
export class CompanyApiService {
  constructor(private http: HttpClient) {}

  addCompany = (newCompany: Company) => this.http.post('/api/v1.0/companies', newCompany);

  updateCompany = (companyForm: Company) => this.http.put<Company>(`/api/v1.0/companies/`, companyForm);

  getCompanies = () => this.http.get('/api/v1.0/companies');

  getCompany = (companyId: string) => this.http.get(`/api/v1.0/companies/${companyId}`);

  getCompanyStyles = (companyId: string) => this.http.get(`/api/v1.0/companies/styles/${companyId}`);

  getCompanyStylesByDomain = () => this.http.get(`/api/v1.0/companies/styles`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUsersPaged = (params: Record<string, any>) =>
    this.http.get<any>(`/api/v1.0/companies/userspaged`, {
      params,
    });

  contactUsers = (req: Record<string, unknown>) => this.http.post('/api/v1.0/companies/users/contact', req);

  sendInvites = (req: Record<string, unknown>) => this.http.post('/api/v1.0/companies/invites', req);

  validatesInvites = (req: Record<string, unknown>) => this.http.post('/api/v1.0/companies/invites/validate', req);

  addLabelToUser = (companyId: string, params: Record<string, unknown>) =>
    this.http.post(`/api/v1.0/companies/${companyId}/userlabels`, params);

  removeLabelsFromUser = (companyId: string, params: Record<string, unknown>) =>
    this.http.delete(`/api/v1.0/companies/${companyId}/userlabels`, { body: params });

  addBulkLabelsToUser = (companyId: string, params: Record<string, unknown>) =>
    this.http.post(`/api/v1.0/companies/${companyId}/userlabels/bulk`, params);

  removeBulkLabelsFromUser = (companyId: string, params: Record<string, unknown>) =>
    this.http.delete(`/api/v1.0/companies/${companyId}/userlabels/bulk`, { body: params });

  postOpenFormLink = (params: Record<string, unknown>) => this.http.post(`/api/v1.0/companies/open-form-link`, params);

  putOpenFormLink = (req: Record<string, unknown>) => this.http.put('/api/v1.0/companies/open-form-link', req);

  getOpenFormLinkByCompId = (companyId: string) =>
    this.http.get(`/api/v1.0/companies/open-form-link/company/${companyId}`);

  checkOpenFormLink = (openFormId: string) => this.http.get(`/api/v1.0/companies/open-form-link/${openFormId}/active`);

  joinOpenFormLink = (openFormId: string, req?: Record<string, unknown>) =>
    this.http.post(`/api/v1.0/companies/open-form-link/${openFormId}/join`, req);

  getCompanyUsers = (companyId: string, includeModerators?: boolean, searchValue?: string) => {
    let params = new HttpParams();
    params = params.set('companyId', companyId);
    if (includeModerators) {
      params = params.set('moderators', 'true');
    }
    if (searchValue) {
      params = params.set('search.value', searchValue);
    }
    return this.http.get(`/api/v1.0/companies/${companyId}/users`, { params });
  };

  inviteCompanyUser = (companyId: string, email: string, role: UserRole) =>
    this.http.post(`/api/v1.0/companies/${companyId}/users`, { email, id: companyId, role });

  removeCompanyUser = (companyId: string, userID: string) =>
    this.http.delete(`/api/v1.0/companies/${companyId}/users/${userID}`);

  removeInvitation = (companyId: string, email: string) =>
    this.http.delete(`/api/v1.0/companies/${companyId}/invite?email=${email}`);

  acceptCompanyInvite = (inviteId: string) => this.http.post(`/api/v1.0/companies/invite/${inviteId}/accept`, {});

  getMenu = (companyId: string) => this.http.get<CompanyMenu>(`/api/v1.0/companies/${companyId}/menu`);
}
